export function createWorkItemLine (kind) {
  return {
    id: Date.now() + Math.random(),
    kind: kind,
    open: true,
    removeItemId: '',
    removeName: '',
    removeNumber: '',
    removeSerial: '',
    removeQty: 1,
    removeHasSerialNumber: false,
    returnItemId: '',
    returnName: '',
    returnNumber: '',
    returnSerial: '',
    returnQty: 1,
    returnHasSerialNumber: false
  }
}

export function buildEngineerWorkItems (workItemLines) {
  const emptySide = () => ({
    itemId: '',
    number: '',
    name: '',
    bomName: '',
    realQuantity: 0,
    quantity: 0,
    hasSerialNumber: false,
    isCustomerDevice: false,
    customerDeviceType: 0,
    installPosition: 0,
    workType: 0,
    originalSerialNumber: '',
    serialNumber: ''
  })
  const hasContent = (side) =>
    !!(side && (side.itemId || side.name || String(side.serialNumber || '').trim()))

  return workItemLines
    .map((line) => {
      const isRemove = line.kind === 'remove'
      const removeItem = isRemove
        ? {
          itemId: line.removeItemId || '',
          number: line.removeNumber || '',
          name: line.removeName || '',
          bomName: '',
          realQuantity: Number(line.removeQty) || 0,
          quantity: Number(line.removeQty) || 0,
          hasSerialNumber: !!String(line.removeSerial || '').trim(),
          isCustomerDevice: false,
          customerDeviceType: 0,
          installPosition: 0,
          workType: 1,
          originalSerialNumber: line.removeSerial || '',
          serialNumber: line.removeSerial || ''
        }
        : emptySide()
      const returnItem = !isRemove
        ? {
          itemId: line.returnItemId || '',
          number: line.returnNumber || '',
          name: line.returnName || '',
          bomName: '',
          realQuantity: Number(line.returnQty) || 0,
          quantity: Number(line.returnQty) || 0,
          hasSerialNumber: !!String(line.returnSerial || '').trim(),
          isCustomerDevice: false,
          customerDeviceType: 0,
          installPosition: 0,
          workType: 2,
          originalSerialNumber: '',
          serialNumber: line.returnSerial || ''
        }
        : emptySide()
      return {
        reason: '',
        removeItem: hasContent(removeItem) ? removeItem : emptySide(),
        returnItem: hasContent(returnItem) ? returnItem : emptySide()
      }
    })
    .filter((row) => hasContent(row.removeItem) || hasContent(row.returnItem))
}
